<template>
  <div-unit
    unitTitle="Dynamic ClinSR for"
    :customHTML="dis_value_show"
    :unitTitle2="`based on ${xxx[calMethod]}`"
    v-loading="checkRateTrendData"
  >
    <SuccessRateHomeNew
      :plotRateTrendData="graph"
      :calMethod="calMethod"
    ></SuccessRateHomeNew>
  </div-unit>
</template>
  
  <script>
import DivUnit from "@/components/DivUnit.vue";
import api from "@/api/index";
import SuccessRateHomeNew from "@/components/home/SuccessRateHomeNew.vue";
export default {
  name: "SuccessRateWindows",
  data() {
    return {
      plotRateTrendData: {},
      checkRateTrendData: true,
      xxx: {
        'CDPs':'Clinical Development Programs (CDPs)',
        'MEs':'Molecular Entities (MEs)',
      },
    };
  },
  props: {
    calMethod: {
      type: String,
      required: true,
    },
    dis_value_show: {
      type: String,
      required: true,
    },
    dis_value: {
      type: String,
      required: true,
    },
  },

  components: {
    DivUnit,
    SuccessRateHomeNew,
  },
  computed: {
    graph() {
      if (this.plotRateTrendData && this.plotRateTrendData[this.dis_value]) {
        return this.plotRateTrendData[this.dis_value];
      }
      return {};
    },
  },
  mounted() {
    api.getSuccessRateTrend(this.calMethod).then((res) => {
      this.plotRateTrendData = res.data;
      this.checkRateTrendData = false;
    });
  },
};
</script>
  

<style scoped>
</style>
  